import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import CategoriesMain from "../Components/Categories Resale/categoriesMain";
import AddCategories from "../Components/Categories Resale/addCategories";
import EditCategories from "../Components/Categories Resale/editCategories";
import AddSubCategories from "../Components/Categories Resale/addSubCategories";
import AddSubSubCategories from "../Components/Categories Resale/addSubSubCategories";
import EditSubCategories from "../Components/Categories Resale/editSubCategory";
import EditSubSubCategories from "../Components/Categories Resale/editSubSubCategory";
import ViewCategory from "../Components/Categories Resale/viewCategory";
import ViewSubCategory from "../Components/Categories Resale/viewSubCategory";

const CategoriesRoutes = () => {
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];

  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');
  return (
    <Routes>
      <Route path="/categories" element={<CategoriesMain />}></Route>
      <Route path="/categories/add" element={canAdd ? <AddCategories /> : <Navigate to="/categories" replace /> }></Route>
      <Route path="/categories/edit/:id" element={canEdit ? <EditCategories /> : <Navigate to="/categories" replace />}></Route>
      <Route
        path="/categories/:id/sub/add"
        element={<AddSubCategories />}
      ></Route>
      <Route
        path="/categories/view/:id"
        element={<ViewCategory />}
      ></Route>
      <Route
        path="/categories/view/sub/edit/:id"
        element={<EditSubCategories />}
      ></Route>
      <Route
        path="/categories/:id/sub/sub/add"
        element={<AddSubSubCategories />}
      ></Route>
      <Route
        path="/categories/sub/sub/view/:id"
        element={<ViewSubCategory />}
      ></Route>
      <Route
        path="/categories/view/sub/sub/edit/:id"
        element={<EditSubSubCategories />}
      ></Route>
    </Routes>
  );
};

export default CategoriesRoutes;
